import queryString from 'query-string'
import { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { saveAllInOneToken } from '../../use-cases/saveAllInOneToken'

export function useSaveAllInOneToken() {
  const location = useLocation()
  const history = useHistory()
  const parsed = useMemo(() => queryString.parse(location.search), [location.search])

  useEffect(() => {
    if (typeof parsed.token === 'string') {
      const urlToken = parsed.token

      saveAllInOneToken(urlToken)

      history.replace({
        search: queryString.stringify({
          ...parsed,
          token: undefined,
        }),
      })
    }
  }, [parsed, history])
}
